export default __webpack_public_path__ + "static/media/loader-file.69e005ca.svg";